/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { AbstractResourceService, JsonApiResource } from "@irian-ro/abstract-resource";
import {
  ShipmentStatusChangeDtoModel,
  ShipmentStatusMetadataModel,
  ShipmentStatusVoModel
} from "@well/domain";
import { HttpClient } from "@angular/common/http";
import {EnvironmentService} from "@irian-ro/util-environment";
import {Observable} from "rxjs";
import {Injectable} from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class ShipmentStatusResourceService extends AbstractResourceService<any, ShipmentStatusChangeDtoModel, any, any> {

  constructor(httpClient: HttpClient, environmentService: EnvironmentService) {
    super(
      httpClient,
      environmentService.getEnvironmentProperty('shipmentStatusChangeUrl'),
      undefined,
      ShipmentStatusChangeDtoModel
    );
  }

  getHistory(shipmentUuid: string): Observable<JsonApiResource<ShipmentStatusVoModel[], ShipmentStatusMetadataModel> > {
    return <Observable<JsonApiResource<ShipmentStatusVoModel[], ShipmentStatusMetadataModel> >>this.httpClient?.get(`${this.url}/history/${shipmentUuid}`);
  }

}
